import * as React from 'react';
import { ConditionalWrapper } from '@cian/conditional-component';
import { path } from 'ramda';
import { useDeviceType } from '@cian/ui-kit';

import { useQuestionsMapper } from './utils/useQuestionsMapper';
import { formContextObj } from './context';
import { QuestionSwitchAnim } from '../../components/QuestionSwitchAnim';

export const FormContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const {
    currentQuestion,
    setNextStep,
    setPrevStep,
    setAnswer,
    answersState,
    setAnswersState,
    registerBackInterceptor,
    unRegisterBackInterceptor,
    isSetPrev,
  } = React.useContext(formContextObj);
  const deviceType = useDeviceType();

  const QuestionComponent = useQuestionsMapper({
    code: currentQuestion.code,
    type: currentQuestion.type,
    answerType: currentQuestion.answerType,
    isLast: path(['extras', 'isLast'], currentQuestion),
  });

  return (
    <ConditionalWrapper
      if={deviceType !== 'desktop'}
      thenRender={child => (
        <QuestionSwitchAnim questionKey={currentQuestion.code} isSetPrev={isSetPrev}>
          {child}
        </QuestionSwitchAnim>
      )}
    >
      <QuestionComponent
        question={currentQuestion}
        setAnswer={setAnswer}
        answersState={answersState}
        setNextStep={setNextStep}
        setPrevStep={setPrevStep}
        registerBackInterceptor={registerBackInterceptor}
        unRegisterBackInterceptor={unRegisterBackInterceptor}
        setAnswersState={setAnswersState}
      />
    </ConditionalWrapper>
  );
};

FormContainer.displayName = 'FormContainer';
